import { createI18n } from 'vue-i18n'
import type { WritableComputedRef } from 'vue'

import type { Locale } from '@/types/resume.types'
import { messages, type MessageSchema } from '@/i18n/messages'

const STORAGE_KEY = 'um_lang'

/** Поддерживаемые локали в порядке циклического переключения (EN → RU → UZ). */
export const SUPPORTED_LOCALES: readonly Locale[] = ['en', 'ru', 'uz']

/** Читает сохранённую локаль из localStorage, иначе — дефолт 'en'. */
function resolveInitialLocale(): Locale {
  const saved = localStorage.getItem(STORAGE_KEY)
  return saved !== null && SUPPORTED_LOCALES.includes(saved as Locale) ? (saved as Locale) : 'en'
}

export const i18n = createI18n<[MessageSchema], Locale>({
  legacy: false,
  globalInjection: true,
  locale: resolveInitialLocale(),
  fallbackLocale: 'en',
  messages,
})

/**
 * Реактивная ссылка на текущую локаль.
 *
 * В composition-режиме (`legacy: false`) `i18n.global.locale` в рантайме — это
 * `WritableComputedRef<Locale>`, но типизированный `createI18n` схлопывает его тип
 * до значения-объединения. Единственный приведение типа на границе с библиотекой,
 * чтобы остальной код оставался строго типизированным.
 */
export const localeRef = i18n.global.locale as unknown as WritableComputedRef<Locale>

// Типизация $t: подсказки по ключам сообщений во всех компонентах.
declare module 'vue-i18n' {
  export interface DefineLocaleMessage extends MessageSchema {}
}
